import type React from "react";

import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { BaseButton } from "shared/atoms/BaseButton";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";

interface Props {
  weeksMissingExercises: number[];
  onRevert: () => void;
  onIgnoreMissingExercises: () => void;
  canRevert: boolean;
}

export const NoExercisesConfirmDialog: React.FC<Props> = ({
  weeksMissingExercises,
  onRevert,
  canRevert,
  onIgnoreMissingExercises,
}) => {
  const { t } = useTranslation();

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <MUIUnifiedModal open onClose={() => {}} showCloseButton={false} width="650px">
      <Stack direction="column" alignItems="center" justifyContent="center" px={3} py={2}>
        <Typography variant="h3" align="center">
          {canRevert
            ? t("usercourse.templates.no_exercises_for_week_warning.title", {
                weeks: weeksMissingExercises?.join(", "),
              })
            : t("usercourse.templates.no_exercises_for_week_warning.title_no_revert", {
                weeks: weeksMissingExercises?.join(", "),
              })}
        </Typography>
        <ButtonsContainer>
          {canRevert && (
            <BaseButton text={t("usercourse.templates.no_exercises_for_week_warning.undo")} onClick={onRevert} small />
          )}
          <BaseButton
            text={t("usercourse.templates.no_exercises_for_week_warning.continue")}
            onClick={onIgnoreMissingExercises}
            variant="secondary"
            small
          />
        </ButtonsContainer>
      </Stack>
    </MUIUnifiedModal>
  );
};

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;

  & > button {
    flex-grow: 0;
    flex-basis: auto;

    &:first-of-type {
      margin-right: 8px;
    }
  }
`;
